module.exports = __webpack_public_path__ + "img/landing-2.9757d88e.png";